import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'parameters/ui'

interface Props {
	text: string
	icon: JSX.Element
}

export const Badge = ({ text, icon }: Props): JSX.Element => (
	<BadgeWrapper>
		{icon}
		<BadgeText>{text}</BadgeText>
	</BadgeWrapper>
)

export const BadgeWrapper = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 40px;
	border-radius: 36px;
	background-color: ${colors.white};
	padding: 0 16px;
	text-transform: uppercase;
`

const BadgeText = styled.span`
	font-size: 18px;
	color: ${colors.primaryPurple1};
	padding-left: 8px;
`
